/**
 * Scroll-triggered entrances for sections with `data-reveal`.
 */
( function() {
	const sections = document.querySelectorAll( '[data-reveal]' );

	if ( ! sections.length ) {
		return;
	}

	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	if ( ! ( 'IntersectionObserver' in window ) ) {
		return;
	}

	const observer = new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			if ( ! entry.isIntersecting ) {
				return;
			}

			entry.target.classList.add( 'is-visible' );

			observer.unobserve( entry.target );
		} );
	}, {
		rootMargin: '0px 0px -12% 0px',
	} );

	sections.forEach( function( section ) {
		section.classList.add( 'is-armed' );
		observer.observe( section );
	} );
}() );
